export default [
  {
    path: 'template-role-show/:roleId',
    name: 'TemplateRoleShow',
    component: () => import('@/views/Setting/RoleTemplate/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting-template-role-show',
    },
  },
  {
    path: 'setting-main',
    name: 'setting',
    component: () => import('@/views/Setting/Setting.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting',
    },
  },
  {
    path: 'role-create',
    name: 'roleCreate',
    component: () => import('@/views/Setting/Role/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting-create-role',
    },
  },
  {
    path: 'role-template-content/:roleId',
    name: 'roleTemplateContent',
    component: () => import('@/views/Setting/RoleTemplate/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting-template-role-show',
    },
  },
  {
    path: 'role-content/:roleId',
    name: 'roleContent',
    component: () => import('@/views/Setting/Role/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting-role-show',
    },
  },
  {
    path: 'role-update/:roleId',
    name: 'roleUpdate',
    component: () => import('@/views/Setting/Role/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting-role-update',
    },
  },
  {
    path: 'setting-password',
    name: 'settingPassword',
    component: () => import('@/views/Setting/PasswordSetting.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting',
    },
  },
  {
    path: 'member-update/:memberId',
    name: 'memberUpdate',
    component: () => import('@/views/Setting/MemberEdit.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting',
    },
  },
  {
    path: 'factory-update',
    name: 'factoryUpdate',
    component: () => import('@/views/Setting/UpdateFactory.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting',
    },
  },
  {
    path: 'batch-scopes',
    name: 'batchScopes',
    component: () => import('@/views/Setting/BatchScopes.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting',
    },
  },
  {
    path: 'search-scope',
    name: 'searchScope',
    component: () => import('@/views/Setting/SearchScope.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'setting',
    },
  },
  {
    path: 'agent-auth-index',
    name: 'agentAuthIndex',
    component: () => import('@/views/Agent/MyIndex.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'setting-agent',
      template: 'auth',
    },
  },
  {
    path: 'agent-auth-create/:userId',
    name: 'agentAuthCreate',
    component: () => import('@/views/Agent/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'setting-agent',
      template: 'auth',
    },
  },
  {
    path: 'agent-create',
    name: 'agentCreate',
    component: () => import('@/views/Agent/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'setting-agent',
      template: 'auth',
    },
  },
  {
    path: 'agent-content/:id',
    name: 'agentContent',
    component: () => import('@/views/Agent/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'setting-agent',
      template: 'auth',
    },
  },
  {
    path: 'agent-update/:id',
    name: 'agentUpdate',
    component: () => import('@/views/Agent/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'setting-agent',
      template: 'auth',
    },
  },
];
